// extracted by mini-css-extract-plugin
export var createdDate = "_mz-1";
export var divider = "_mz-2";
export var headerDivider = "_mz-3";
export var messagesCard = "_mz-0";
export var messagesContainer = "_mz-6";
export var messagesContainerWrapper = "_mz-4";
export var showLeftPanelButton = "_mz-8";
export var topButtons = "_mz-7";
export var withPadding = "_mz-5";